import { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icons } from '../utils/icons';
import { useLanguage } from "../contexts/LanguageContext";
import { CategoryDropdownProps } from "../types/Props";
import { categoryColors } from "../utils/serviceCategoryUtils";

const CategoryFilterDropdown = ({ 
  shouldClose, 
  onCloseHandled, 
  selectedCategories, 
  setSelectedCategories
}: CategoryDropdownProps) => {
  const { translations } = useLanguage();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const allCategories = [
    'accommodation', 'attraction', 'restaurant', 'shop',
    'rental_service', 'transportation',
  ] as const;

  // Close the menu when clicked outside of it
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Close the menu, Listening from outside
  useEffect(() => {
    if (shouldClose) {
      if (open) {
        setOpen(false);
      }
      onCloseHandled();
    }
  }, [shouldClose, open, onCloseHandled]);

  return (
    <div className="category-dropdown" ref={dropdownRef}>
      <button
        onClick={() => setOpen(!open)}
        className="category-dropdown-button"
      >
        {translations.servicemap.choosecategories}
        <FontAwesomeIcon icon={open ? icons.chevronDown : icons.chevronRight} className='icon-right'/>
      </button>

      {open && (
        <div className="category-dropdown-list">
          {allCategories.map((category) => (
            <label key={category} className="checkbox-container category-checkbox">
              <span
                className="category-color-dot"
                style={{ backgroundColor: categoryColors[category] || "#ccc" }}
              />
              <input
                type="checkbox"
                checked={selectedCategories.includes(category)}
                onChange={() => {
                  setSelectedCategories((prev) =>
                    prev.includes(category)
                      ? prev.filter((c) => c !== category)
                      : [...prev, category]
                  );
                }}
              />
              <div className='checkmark category-checkmark'></div>
              {selectedCategories.includes(category) 
                ? <strong>{translations.servicemap[category]}</strong> 
                : <>{translations.servicemap[category]}</>
              }
            </label>
          ))}
        </div>
      )}
    </div>
  );
}

export default CategoryFilterDropdown;